import { defineComponent, openBlock, createElementBlock, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaNavbarItem_vue_vue_type_style_index_0_lang = "";
const _sfc_main = defineComponent({
  name: "VaNavbarItem",
  props: {}
  // TODO: In web components build props are required (it's a vue bug)
});
const _hoisted_1 = { class: "va-navbar__item" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const _VaNavbarItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaNavbarItem as _
};

import '../../../../VaNavbarItem.css';
//# sourceMappingURL=VaNavbarItem-af4ae844.mjs.map
